<template>
  <div class="medication-timing-period-unit-input">
    <el-select
      v-model="currentInput"
      filterable
      placeholder="Unidad de Tiempo"
      @input="handleSearchItemSelect"
      @blur="search = ''">
      <el-option
        v-for="unitOfTime in filteredUnitsOfTime"
        :key="unitOfTime.code"
        :label="unitOfTime.display"
        :value="unitOfTime.code" />
    </el-select>
  </div>
</template>

<script>
import _deburr from 'lodash/deburr';

export default {
  name: 'MedicationUnitsOfTimeInput',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentInput: this.value,
      search: ''
    };
  },
  computed: {
    filteredUnitsOfTime() {
      return this.unitsOfTime.filter(m => {
        return _deburr(m.display).includes(this.search);
      });
    },
    unitsOfTime() {
      return this.$store.getters.unitsOfTime;
    }
  },
  methods: {
    handleFilter(value) {
      this.search = value;
    },
    handleSearchItemSelect(value) {
      this.$emit('input', value);
      this.search = '';
    }
  }
};
</script>

<style lang="scss">
</style>
